import briefcaseIcon from "../../../assets/svg/accountIcons/briefcase.svg";
import profileIcon from "../../../assets/svg/accountIcons/profile.svg";
import mailIcon from "../../../assets/svg/accountIcons/mail.svg";
import boxIcon from "../../../assets/svg/accountIcons/box.svg";
import anchorIcon from "../../../assets/svg/accountIcons/anchor.svg";
import ribbonIcon from "../../../assets/svg/accountIcons/ribbon.svg";
import cubeIcon from "../../../assets/svg/accountIcons/cube.svg";
import cloudIcon from "../../../assets/svg/accountIcons/cloud.svg";
import coffeeIcon from "../../../assets/svg/accountIcons/coffee.svg";
import sunIcon from "../../../assets/svg/accountIcons/sun.svg";
import moonIcon from "../../../assets/svg/accountIcons/moon.svg";
import editIcon from "../../../assets/svg/accountIcons/edit.svg";
import giftIcon from "../../../assets/svg/accountIcons/gift.svg";
import heartIcon from "../../../assets/svg/accountIcons/heart.svg";
import diskIcon from "../../../assets/svg/accountIcons/disk.svg";
import starIcon from "../../../assets/svg/accountIcons/star.svg";

export const getAccountIcon = (iconName: any) => {
    let icon: any;
    switch (iconName) {
      case "profile": {
        icon = profileIcon;
        break;
      }
      case "mail": {
        icon = mailIcon;
        break;
      }
      case "box": {
        icon = boxIcon;
        break;
      }
      case "anchor": {
        icon = anchorIcon;
        break;
      }
      case "ribbon": {
        icon = ribbonIcon;
        break;
      }
      case "cube": {
        icon = cubeIcon;
        break;
      }
      case "cloud": {
        icon = cloudIcon;
        break;
      }
      case "coffee": {
        icon = coffeeIcon;
        break;
      }
      case "sun": {
        icon = sunIcon;
        break;
      }
      case "moon": {
        icon = moonIcon;
        break;
      }
      case "edit": {
        icon = editIcon;
        break;
      }
      case "gift": {
        icon = giftIcon;
        break;
      }
      case "heart": {
        icon = heartIcon;
        break;
      }
      case "disk": {
        icon = diskIcon;
        break;
      }
      case "star": {
        icon = starIcon;
        break;
      }
      default: {
        icon = briefcaseIcon;
        break;
      }
    }

    return icon;
  };